import { IconGeneric } from '@/widgets/components/icon';
import ContactIcon from '@/../img/contact-icon.svg';
import GroupBackground from '@/../img/houses-with-trees.svg';
import PrintIcon from '@/../img/print.svg';
import { Button, Input, InputGroup } from 'rsuite';
import { FaSearch } from 'react-icons/fa';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';

export const StyledInputGroup = styled(InputGroup)`
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
`;

export const StyledInput = styled(Input)`
  width: 520px !important;
  height: 36px;
  margin-right: 16px;
  border: 1px solid ${cssVars.color.helpPageColor.borderGrey};
  background-color: ${cssVars.color.helpPageColor.white};

  ::placeholder {
    width: 143px;
    height: 18px;
    font-family: 'Nunito Sans';
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.5);
  }
`;

export const SearchWrapper = styled.div`
  width: 650px;
  height: 36px;
  display: flex;
`;

export const SearchTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  bottom: 20px;
  right: 60px;
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-content: center;
  width: 120px;
  height: 36px;
  border-radius: 6px;
  &.rs-btn-default {
    color: ${cssVars.color.helpPageColor.white};
    background-color: ${cssVars.color.rentalscapeBlue};
  }
`;

export const StyledSearchIcon = styled(FaSearch)`
  width: 16px;
  height: 16px;
  opacity: 0.25;
`;

export const StyledLink = styled(Button)`
  width: 66px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  color: rgba(16, 25, 56, 0.55);
  position: relative;
  bottom: 7px;
  right: 9px;
`;

export const StyledChevron = styled(IconGeneric)`
  color: rgba(16, 25, 56, 0.55);
`;

export const HelpCenterLinkWrapper = styled.div`
  position: absolute;
  left: 38px;
  top: 32px;
  display: flex;
  width: 80px;
  color: rgba(16, 25, 56, 0.55);
  cursor: pointer;
`;

export const StyledButtonTitle = styled.div`
  position: relative;
  width: 43px;
  font-family: 'Nunito Sans';
  font-size: 14px;
  text-align: center;
  color: ${cssVars.color.helpPageColor.white};
  margin: 0 auto;
  ::before {
    content: '${(props) => props.content}';
  }
`;

export const RentalscapeTitle = styled.span`
  color: ${cssVars.color.rentalscapeBlue};
  width: 580px;
  font-size: 70px;
  font-weight: 700;
  letter-spacing: 4px;
  line-height: 1;
  margin-bottom: 23px;
  position: relative;
  left: 80px;
  ::before {
    content: 'rentalscape';
  }
`;

export const StyledInvisibleButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 4px;
  margin-right: 36px;
  padding: 0px;
  border: none;
  height: 36px;
  background-color: transparent;
  :focus {
    outline: none;
  }
  &:hover {
    background-color: transparent;
  }
`;

export const StyledContactIcon = styled(ContactIcon)`
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin: 10px 6px;
`;

export const StyledPrintIcon = styled(PrintIcon)`
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin: 10px 6px;
`;

export const StyledTopRowIconsWrapper = styled.div`
  width: 100%;
  height: 76px;
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding-right: 24px;
  padding-top: 15px;
`;

export const BackgroundSVG = styled(GroupBackground)`
  object-fit: contain;
  align-self: flex-end;
  right: 120px;
  position: absolute;
  bottom: -4px;
`;

export const BackgroundColor = styled.div`
  position: relative;
  top: 0px;
  background-image: linear-gradient(
    to top,
    rgba(241, 245, 255, 0.4) -34%,
    rgba(89, 126, 247, 0.4)
  );
  display: flex;
  justify-content: center;
  width: 100%;
  height: 260px;
  object-fit: contain;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 260px;
  position: relative;
  top: 0;
  object-fit: contain;
`;
